import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimaDoubleYpsiliRight';
const args = {};

export class OligonKentimaDoubleYpsiliRight extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
